[
  {
    "code": "BY-BR",
    "name": "Brèsckaja voblasc'"
  },
  {
    "code": "BY-HO",
    "name": "Homel'skaja voblasc'"
  },
  {
    "code": "BY-HR",
    "name": "Hrodzenskaja voblasc'"
  },
  {
    "code": "BY-MA",
    "name": "Mahilioúskaja voblasc'"
  },
  {
    "code": "BY-MI",
    "name": "Minskaja voblasc'"
  },
  {
    "code": "BY-VI",
    "name": "Vicebskaja voblasc'"
  }
]